module.exports = __webpack_public_path__ + "img/gdq_gbt93_1987.prt.15c01fa0.jpg";